import { z } from "zod";


export const updateStudentSchema = z.object({
    name: z.string().refine((value) => value.split(" ").length === 3, {
      message: "الاسم يجب أن يكون من ثلاث كلمات",
    }),
    password: z.string().min(8, "كلمة المرور يجب أن تكون على الأقل 8 أحرف"),
    email: z.string().email("البريد الإلكتروني غير صالح"),
  });